import { PRIMARY_PAGE_TEXT_COLOR_VAR } from '../context/CustomizationContextProvider'

/**
 * Add to `ProductImageCarousel` main `.keen-slider` root so global slide rules
 * (`width: 100%`, `flex: 0 0 100%`) do not override auto-width slide sizing.
 */
export const PRODUCT_IMAGE_CAROUSEL_MAIN_KEEN_CLASS =
    'product-image-carousel__mainKeen' as const

export const PLP_GRID_KEEN_CLASS = 'plp-grid__keen' as const

export const keenStyles = `
.keen-slider:not([data-keen-slider-disabled]){
    -webkit-touch-callout:none;
    -webkit-tap-highlight-color:transparent;
    align-content:flex-start;
    display:flex;
    overflow:hidden;
    position:relative;
    touch-action:pan-y;
    -webkit-user-select:none;
    -moz-user-select:none;
    -ms-user-select:none;
    user-select:none;
    -khtml-user-select:none;
    width:100%;
}
.keen-slider:not([data-keen-slider-disabled]):not(.${PRODUCT_IMAGE_CAROUSEL_MAIN_KEEN_CLASS}):not(.${PLP_GRID_KEEN_CLASS}) .keen-slider__slide{
    min-height:100%;
    overflow:hidden;
    position:relative;
    width:100%;
}
.${PLP_GRID_KEEN_CLASS}.keen-slider:not([data-keen-slider-disabled]){
    flex:1 1 auto;
    height:100%;
    min-height:0;
}
.${PLP_GRID_KEEN_CLASS}.keen-slider:not([data-keen-slider-disabled]) .keen-slider__slide{
    display:flex;
    align-items:center;
    justify-content:center;
    min-height:100%;
    overflow:hidden;
    position:relative;
    width:100%;
}
/* Without slider JS, flex defaults shrink all slides to fit one row — images become tiny.
   Full-width slides overflow horizontally; .keen-slider overflow:hidden keeps one in view. */
.keen-slider:not([data-keen-slider-disabled]):not([data-keen-slider-v]):not(.${PRODUCT_IMAGE_CAROUSEL_MAIN_KEEN_CLASS}) .keen-slider__slide{
    flex:0 0 100%;
    min-width:100%;
}

/* PDP / inline product carousel: auto-width slides sized by image content. */
.${PRODUCT_IMAGE_CAROUSEL_MAIN_KEEN_CLASS}.keen-slider:not([data-keen-slider-disabled]) .keen-slider__slide{
    flex:0 0 auto;
    width:auto;
    min-width:auto;
    max-width:100%;
}
.keen-slider:not([data-keen-slider-disabled])[data-keen-slider-reverse]{
    flex-direction:row-reverse;
}
.keen-slider:not([data-keen-slider-disabled])[data-keen-slider-v]{
    flex-wrap:wrap;
}
.dots {
    display: flex;
    padding: 8px 0;
    justify-content: center;
  }
  
.dot {
  border-radius: 50%;
  width: 8px;
  height: 8px;
  margin: 0 4px;
  padding: 0;
  cursor: pointer;
  border: none;
  background: color-mix(in srgb, var(${PRIMARY_PAGE_TEXT_COLOR_VAR}) 18%, transparent 82%);
  transition: background-color 0.18s ease-out,
              transform 0.18s ease-out,
              opacity 0.18s ease-out;
  opacity: 0.9;
}

.dot:focus {
outline: none;
}

.dot.active {
  background: var(${PRIMARY_PAGE_TEXT_COLOR_VAR});
  transform: scale(1.05);
  opacity: 1;
}
`
